module.exports = __webpack_public_path__ + "img/preview-5.4e99e998.webp";